export enum PlayerState {
  CINEMATIC = 'cinematic',
  INTRO = 'intro',
  SMART_SEQUENCE = 'smart-sequence',
  SUMMARY = 'summary',
}
